import { Component } from '@verndale/core';
import Swiper from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';

class GenericCarousel extends Component {
  swiperInstance: Swiper | undefined = undefined;

  setupDefaults() {
    this.dom = {
      $swiperContainer: this.el.querySelector<HTMLElement>('.swiper-container'),
      $swiperNext: this.el.querySelector<HTMLElement>('.btn-next-slide'),
      $swiperPrevious: this.el.querySelector<HTMLElement>('.btn-previous-slide'),
      $swiperScroll: this.el.querySelector<HTMLElement>('.generic-carousel__pagination-container')
    };

    this.initSlider();
  }

  initSlider() {
    if (this.dom.$swiperContainer) {
      const isGenericCard = this.el.classList.contains('generic-carousel--generic-card');
      const isMagazineCard = this.el.classList.contains('generic-carousel--magazine-card');

      this.swiperInstance = new Swiper(this.dom.$swiperContainer as HTMLElement, {
        modules: [Navigation, Pagination, A11y],
        keyboard: {
          enabled: false
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 40
          },
          768: {
            slidesPerView: isGenericCard ? 2.6 : isMagazineCard ? 4 : 3,
            spaceBetween: 40
          },
          1440: {
            slidesPerView: isGenericCard ? 2.6 : isMagazineCard ? 4 : 3.1,
            spaceBetween: 40
          },
          1620: {
            slidesPerView: isGenericCard ? 2.6 : isMagazineCard ? 4 : 3.5,
            spaceBetween: 40
          }
        },
        a11y: {
          enabled: true
        },
        // Navigation arrows
        navigation: {
          nextEl: this.dom.$swiperNext as HTMLElement,
          prevEl: this.dom.$swiperPrevious as HTMLElement
        },
        pagination: {
          el: this.dom.$swiperScroll as HTMLElement,
          type: 'progressbar'
        }
      });
    }
  }
}

export default GenericCarousel;
